import axios from './axios';

export const paymentsAPI = {
  // Dashboard summary
  getDashboardSummary: async () => {
    const response = await axios.get('/payments/dashboard/summary');
    return response.data;
  },

  // Get all payments with filters
  getAll: async (params) => {
    const response = await axios.get('/payments', { params });
    return response.data;
  },

  // Get payment by ID
  getById: async (id) => {
    const response = await axios.get(`/payments/${id}`);
    return response.data;
  },

  // Create payment
  create: async (data) => {
    const response = await axios.post('/payments', data);
    return response.data;
  },

  // Get daily summary
  getDailySummary: async (date) => {
    const response = await axios.get('/payments/summary/daily', { 
      params: { date } 
    });
    return response.data;
  },

  // Wallet operations
  getWalletSummary: async () => {
    const response = await axios.get('/payments/wallet/summary');
    return response.data;
  },

  depositWallet: async (data) => {
    const response = await axios.post('/payments/wallet/deposit', data);
    return response.data;
  },

  // Credit operations
  getCreditSummary: async () => {
    const response = await axios.get('/payments/credit/summary');
    return response.data;
  },

  getOutstandingCredits: async () => {
    const response = await axios.get('/payments/credit/outstanding');
    return response.data;
  },

  updateCreditLimit: async (data) => {
    const response = await axios.post('/payments/credit/update-limit', data);
    return response.data;
  },

  settleOrders: async (data) => {
    const response = await axios.post('/payments/credit/settle', data);
    return response.data;
  },

  // Receipt and Invoice
  getReceipt: async (paymentId) => {
    const response = await axios.get(`/payments/${paymentId}/receipt`);
    return response.data;
  },

  generateInvoice: async (paymentId) => {
    const response = await axios.get(`/payments/${paymentId}/invoice`);
    return response.data;
  },

  // Refund payment
  refund: async (paymentId, data) => {
    const response = await axios.post(`/payments/${paymentId}/refund`, data);
    return response.data;
  },
};
